/* 2026-10-07: gentler dropdown menus (Sports / Organizations).
   The original handlers in patriot.js closed the menu the instant the mouse
   left the button, and there is a small gap between the button and the
   panel, so the menu snapped shut before you could reach it. This replaces
   those handlers: opens after a short pause, and stays open for ~0.5s after
   the mouse leaves so you can move into the panel. Remove the line in
   snippets/pt-head.liquid to undo.
   2026-10-15: added the per-sport styles panel. Hovering a sport row swaps
   the right-hand panel to that sport's bodies instantly (no delay), and
   leaving the menu resets it to the first sport. */
(function () {
  'use strict';
  var OPEN_DELAY = 90;   // ms before opening on hover
  var CLOSE_DELAY = 550; // ms grace period before closing

  function init() {
    var items = document.querySelectorAll('.pt-nav > li.has-mega');
    if (!items.length) return;
    var all = [];
    items.forEach(function (orig) {
      // Swap in a clean copy so the old instant-close listeners are gone.
      var li = orig.cloneNode(true);
      orig.parentNode.replaceChild(li, orig);
      all.push(li);
    });

    function closeOthers(keep) {
      all.forEach(function (o) {
        if (o !== keep) {
          o.classList.remove('is-open');
          var b = o.querySelector(':scope > button');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });
    }
    function setOpen(li, open) {
      li.classList.toggle('is-open', open);
      var b = li.querySelector(':scope > button');
      if (b) b.setAttribute('aria-expanded', String(open));
    }

    all.forEach(function (li) {
      var openT, closeT;
      li.addEventListener('mouseenter', function () {
        clearTimeout(closeT);
        if (li.classList.contains('is-open')) return;
        // If another menu is already open, switch right away.
        var anyOpen = all.some(function (o) { return o.classList.contains('is-open'); });
        openT = setTimeout(function () { closeOthers(li); setOpen(li, true); }, anyOpen ? 0 : OPEN_DELAY);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(openT);
        closeT = setTimeout(function () { setOpen(li, false); }, CLOSE_DELAY);
      });
      var btn = li.querySelector(':scope > button');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(openT); clearTimeout(closeT);
          var open = li.classList.contains('is-open');
          closeOthers(li);
          setOpen(li, !open);
        });
      }
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) setOpen(li, false);
      });
    });

    // Per-sport styles panel: hovering a sport swaps the panel with no delay.
    all.forEach(function (li) {
      var host = li.querySelector('[data-ptstyles]');
      if (!host) return;
      var panels = [].slice.call(host.querySelectorAll('[data-ptpanel]'));
      var rows = [].slice.call(li.querySelectorAll('a[data-ptsport]'));
      if (!panels.length || !rows.length) return;
      var first = panels[0].getAttribute('data-ptpanel');

      function show(h) {
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-ptpanel') !== h; });
        rows.forEach(function (r) { r.classList.toggle('is-cur', r.getAttribute('data-ptsport') === h); });
      }
      rows.forEach(function (r) {
        var h = r.getAttribute('data-ptsport');
        r.addEventListener('mouseenter', function () { show(h); });
        r.addEventListener('focus', function () { show(h); });
      });
      li.addEventListener('mouseleave', function () { show(first); });
      show(first);
    });

    // Click anywhere outside closes any open menu.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.pt-nav > li.has-mega')) closeOthers(null);
    });
  }

  // patriot.js is loaded with defer too; wait until it has run, then replace.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }
})();